import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitSwitchingOnOffering = createSelector(
  [selectFinancialCockpitState],
  ({ switchingOnOffering }) => switchingOnOffering
)
